/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import { format } from 'date-fns'
// import moment from 'moment'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import CardFooter from 'components/CardFooter'
import Button from 'components/Button'
import Dialog from 'components/Dialog'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./AccountAndLoanList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class LockedAccountList extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object,
    accountType: PropTypes.string.isRequired,
    deleteLockedAccount: PropTypes.func.isRequired,
    header: PropTypes.string,
    lockedAccountItems: PropTypes.instanceOf(Array),
    openLockedAccountForm: PropTypes.func.isRequired,
  }
  static defaultProps = {
    accountsAndLoans: null,
    lockedAccountItems: {},
    header: '',
  }
  constructor(props) {
    super(props)
    this.state = {
      confirmDeleteDialogOpen: false,
      submit: false,
      accountSelected: '',
    }
  }
  _openConfirmDeleteDialog = (account) => {
    this.setState({ confirmDeleteDialogOpen: true })
    this.setState({ accountSelected: account })
  }

  _closeConfirmDeleteDialog = () => {
    this.setState({ confirmDeleteDialogOpen: false })
  }

  _saveConfirmDeleteDialog = () => {
    this.setState({
      confirmDeleteDialogOpen: false,
      submit: true,
    })
    this.props.deleteLockedAccount(this.state.accountSelected)
  }

  renderCols = () => {
    return (
      <tr>
        <th className={(styles.columns.description, headerStyles)}>
          Locked account starts with
        </th>
        <th className={(styles.columns.created, headerStyles)}>created</th>
        <th className={(styles.columns.view, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return this.props.lockedAccountItems.length ? (
      this.props.lockedAccountItems.map((lockedAccount, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className={styles.base} key={`${lockedAccount.accountprefix}-${i}`}>
          <td className={styles.lockedaccount}>
            {lockedAccount.accountprefix}
          </td>
          <td>{lockedAccount.time_stamp ? format(new Date(lockedAccount.time_stamp), constants.DATE_FORMAT.STANDARD) : ''}</td>
          <td>{lockedAccount.balance}</td>
          <td>
            <Button
              onClick={() => {
                this._openConfirmDeleteDialog(lockedAccount.accountprefix)
              }}
              type="flat"
            >
              UNLOCK
            </Button>
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noAccountsAndLoans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    const confirmDeleteProps = {
      actions: [
        { label: 'CANCEL', onClick: this._closeConfirmDeleteDialog },
        { label: 'UNLOCK', onClick: this._saveConfirmDeleteDialog },
      ],
      title: 'Are you sure you want to unlock this account?',
      active: this.state.confirmDeleteDialogOpen,
      onClose: this._closeConfirmDeleteDialog,
    }
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
          <CardFooter>
            <div className={styles.buttonContainer}>
              <Button
                onClick={this.props.openLockedAccountForm}
                style={{ marginLeft: 'auto' }}
                type="flat"
              >
                LOCK ACCOUNT
              </Button>
            </div>
          </CardFooter>
        </Card>
        <Dialog {...confirmDeleteProps}>
          You will be not able to bring this back once deleted.
        </Dialog>
      </div>
    )
  }
}

export default LockedAccountList



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/components/AccountAndLoan/LockedAccountList.js